(function casaSearch(){
  'use strict';
  var back, input, results, lastFocus = null;

  function esc(v){
    return String(v == null ? '' : v)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function build(){
    if (back) return;
    back = document.createElement('div');
    back.className = 'casa-search-back';
    back.id = 'casa-search-back';
    back.setAttribute('role','dialog');
    back.setAttribute('aria-modal','true');
    back.setAttribute('aria-label','Search the collection');
    back.innerHTML =
      '<div class="casa-search-panel">' +
        '<div class="casa-search-top">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>' +
          '<input id="casa-search-input" type="search" autocomplete="off" placeholder="Search by brand, model, colour or SKU">' +
          '<button class="casa-search-close" aria-label="Close search">&times;</button>' +
        '</div>' +
        '<div class="casa-search-results" id="casa-search-results"></div>' +
      '</div>';
    document.body.appendChild(back);
    input = back.querySelector('#casa-search-input');
    results = back.querySelector('#casa-search-results');

    back.addEventListener('click', function(e){ if (e.target === back) close(); });
    back.querySelector('.casa-search-close').addEventListener('click', close);
    input.addEventListener('input', function(){ render(input.value); });
    // Enter with exactly one hit is the fastest path to the piece.
    input.addEventListener('keydown', function(e){
      if (e.key === 'Enter'){
        var first = results.querySelector('.casa-sr');
        if (first) first.click();
      }
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && back.classList.contains('open')) close();
    });
  }

  function catalogue(){
    try { return (typeof arrivals !== 'undefined' && Array.isArray(arrivals)) ? arrivals : []; }
    catch(e){ return []; }
  }

  function render(q){
    q = String(q || '').trim().toLowerCase();
    var all = catalogue();
    // Keep the ORIGINAL index — openQuickView(i) indexes into `arrivals`, so a
    // filtered array's index would open the wrong bag.
    var hits = all.map(function(p,i){ return { p:p, i:i }; });
    if (q){
      // Fold accents on BOTH sides (23 Sep 2026): shoppers type "hermes", the
      // catalogue says "Hermès", and a plain toLowerCase() compare found nothing.
      // NFD splits "è" into "e" + a combining mark, which the regex then drops.
      var fold = function(s){
        s = String(s == null ? '' : s).toLowerCase();
        return typeof s.normalize === 'function' ? s.normalize('NFD').replace(/[̀-ͯ]/g, '') : s;
      };
      var terms = fold(q).split(/\s+/);
      hits = hits.filter(function(h){
        var hay = fold([h.p.brand, h.p.name, h.p.sku, h.p.color, h.p.cond, h.p.hardware].join(' '));
        return terms.every(function(t){ return hay.indexOf(t) >= 0; });
      });
    }
    if (!all.length){
      results.innerHTML = '<div class="casa-search-empty">The collection is still loading — try again in a moment.</div>';
      return;
    }
    if (!hits.length){
      results.innerHTML = '<div class="casa-search-empty">Nothing matches “' + esc(q) + '”.<br>' +
        'Looking for something specific? Use <strong>Request a Piece</strong> and we will source it.</div>';
      return;
    }
    results.innerHTML = hits.slice(0, 40).map(function(h){
      var img = h.p.img || (h.p.gallery && h.p.gallery[0]) || '';
      return '<button class="casa-sr" data-i="' + h.i + '">' +
        (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<img alt="">') +
        '<span><span class="casa-sr-b">' + esc(h.p.brand) + '</span>' +
        '<span class="casa-sr-n">' + esc(h.p.name) + '</span></span>' +
        '<span class="casa-sr-p">' + esc(h.p.price) + '</span>' +
      '</button>';
    }).join('');
    results.querySelectorAll('.casa-sr').forEach(function(row){
      row.addEventListener('click', function(){
        var i = Number(row.getAttribute('data-i'));
        close();
        try { if (typeof openQuickView === 'function') openQuickView(i); } catch(e){}
      });
    });
  }

  function open(){
    build();
    lastFocus = document.activeElement;
    back.classList.add('open');
    document.body.style.overflow = 'hidden';
    render('');
    setTimeout(function(){ input.focus(); input.select(); }, 30);
  }
  function close(){
    if (!back) return;
    back.classList.remove('open');
    document.body.style.overflow = '';
    input.value = '';
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch(e){} }
  }

  window.casaOpenSearch = open;
  window.casaCloseSearch = close;

  // ---- Club management: switch tier / cancel ------------------------------
  // WHAT THIS HONESTLY IS. Enrolment is real (Storefront cartCreate with a
  // selling plan). Management is delegated to Shopify's customer account portal,
  // because that is where the subscription contract actually lives.
  //
  // Two limits worth stating rather than papering over:
  //  1. This site does NOT know who is a member. There is no memberships table
  //     and nothing reads subscription state back from Shopify, so we cannot
  //     show "you are Gold" — we would be guessing. Everything here is phrased
  //     so it is true whether or not the visitor holds a membership.
  //  2. Shopify Subscriptions has no plan-swap. Changing tier is cancel +
  //     rejoin, and pretending otherwise with a one-click "Upgrade" would either
  //     silently double-bill or silently do nothing.
  //
  // When a memberships table + subscription_contracts/* webhooks exist, this
  // panel is the seam to upgrade: read the real tier, then offer a true swap.
  (function casaClubManage(){
    function portal(){ return (window.CASA_CONFIG || {}).MEMBER_PORTAL_URL || ''; }

    // Real current tier/status, read the same way the account modal's "Your
    // membership" panel does (GET /api/membership). Was previously generic
    // copy that never reflected whether — or what — the visitor actually held.
    function currentStatusHtml(cb){
      try {
        fetch('/api/membership', { credentials: 'same-origin' })
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(j){
            var rec = j && j.membership;
            if (!rec || !(rec.status === 'active' || rec.status === 'cancelling')) { cb(''); return; }
            var label = escapeHtml(rec.tierLabel || rec.tier || '');
            var price = rec.price ? ' · $' + Number(rec.price).toLocaleString() + '/' + (rec.billingInterval === 'yearly' ? 'year' : 'month') : '';
            var statusWord = rec.status === 'cancelling' ? 'Cancelling' : 'Active';
            var dateLine = '';
            if (rec.currentPeriodEnd) {
              var d = new Date(rec.currentPeriodEnd).toLocaleDateString('en-US', { month:'short', day:'numeric', year:'numeric' });
              dateLine = (rec.status === 'cancelling' ? 'Access until ' : 'Renews ') + d;
            }
            cb('<div class="info-item" style="background:var(--bg); padding:14px 16px; border-radius:2px; margin-bottom:18px;">' +
                 '<h4 style="margin-bottom:4px;">Your current membership</h4>' +
                 '<p style="margin:0;"><strong>' + label + '</strong>' + price + ' — ' + statusWord + (dateLine ? ' · ' + escapeHtml(dateLine) : '') + '</p>' +
               '</div>');
          })
          .catch(function(){ cb(''); });
      } catch(e){ cb(''); }
    }

    window.casaManageClub = function(){
      var p = portal();
      var m = document.getElementById('modal-clubmanage');
      if (!m){
        m = document.createElement('div');
        m.className = 'modal-backdrop'; m.id = 'modal-clubmanage';
        m.setAttribute('onclick', "if(event.target===this) closeModal('clubmanage')");
        m.innerHTML =
          '<div class="modal info-modal">' +
            '<button class="modal-close" aria-label="Close" onclick="closeModal(\'clubmanage\')">' +
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>' +
            '<div class="info-head"><h2>Manage your Club membership</h2>' +
              '<p>Change tier or cancel at any time — no fee, no penalty.</p></div>' +
            '<div class="info-body">' +
              '<div id="clubmanage-status"></div>' +
              '<div class="info-item"><h4>Cancel</h4><p>Cancel whenever you like from your Casa account. ' +
                'Your benefits continue to the end of the month you have paid for, and nothing is charged after that.</p>' +
                (p ? '<p style="margin-top:10px;"><a class="btn btn-primary btn-sm" href="' + p + '" target="_blank" rel="noopener">Open my account →</a></p>'
                   : '<p style="margin-top:10px;color:var(--muted);">Email info@casaconsignment.com and we will cancel it for you the same day.</p>') +
              '</div>' +
              '<div class="info-item" style="margin-top:18px;"><h4>Change tier</h4>' +
                '<p>Moving between Silver, Gold and Elite is done in two steps: cancel the tier you hold, ' +
                'then join the one you want. Your new tier starts immediately; the old one bills nothing further.</p>' +
                '<div style="display:flex; gap:8px; flex-wrap:wrap; margin-top:12px;">' +
                  '<button class="btn btn-ghost btn-sm" onclick="casaStartMembership(\'silver\')">Silver · $149</button>' +
                  '<button class="btn btn-ghost btn-sm" onclick="casaStartMembership(\'gold\')">Gold · $299</button>' +
                  '<button class="btn btn-ghost btn-sm" onclick="casaStartMembership(\'elite\')">Elite · $599</button>' +
                '</div>' +
                // Request route (23 Sep 2026): a signed-in member asks Casa to switch
                // them; staff swap the product on the same Shopify contract, so there is
                // one billing date and no double charge. Filed via /api/intake
                // (membership_change); the server reads the member and current tier.
                '<div class="casa-tier-req" style="margin-top:16px; padding-top:14px; border-top:1px solid var(--line);">' +
                  '<p style="margin:0 0 8px;"><strong>Prefer we handle it?</strong> Choose your new tier and a concierge will switch you. ' +
                  'Your billing date stays the same and the new price applies from your next payment.</p>' +
                  '<div style="display:flex; gap:8px; flex-wrap:wrap; align-items:center;">' +
                    '<select id="casa-tier-to" aria-label="New tier" style="padding:8px 10px; border:1px solid var(--line); background:#fff; font:inherit;">' +
                      '<option value="silver">Silver · $149/month</option><option value="gold">Gold · $299/month</option><option value="elite">Elite · $599/month</option>' +
                    '</select>' +
                    '<button type="button" class="btn btn-primary btn-sm" id="casa-tier-req-btn" onclick="casaRequestTierChange()">Ask Casa to switch me</button>' +
                  '</div>' +
                  '<p id="casa-tier-req-msg" role="status" style="margin:10px 0 0; font-size:13px; line-height:1.6;"></p>' +
                  '<p style="margin-top:8px; font-size:12px; color:var(--muted); line-height:1.6;">' +
                    'Or email <a href="mailto:info@casaconsignment.com" style="color:var(--navy); text-decoration:underline;">info@casaconsignment.com</a>.</p>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>';
        document.body.appendChild(m);
      }
      var statusEl = m.querySelector('#clubmanage-status');
      if (statusEl) currentStatusHtml(function(html){ statusEl.innerHTML = html; });
      openModal('clubmanage');
    };

    window.casaRequestTierChange = function(){
      var msg = document.getElementById('casa-tier-req-msg');
      var btn = document.getElementById('casa-tier-req-btn');
      var sel = document.getElementById('casa-tier-to');
      var say = function(t, bad){ if (msg){ msg.textContent = t; msg.style.color = bad ? '#b3261e' : 'var(--navy)'; } };
      if (!(window.casaUser && window.casaUser.email)) { say('Please sign in to your Casa account first, then try again.', true); return; }
      if (btn) btn.disabled = true;
      say('Sending…');
      fetch('/api/intake', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ type: 'membership_change', data: { to: sel ? sel.value : '' } }) })
        .then(function(r){ return r.json().catch(function(){ return {}; }).then(function(j){ return { ok: r.ok && j && j.ok, j: j }; }); })
        .then(function(x){
          if (x.ok) say('Request sent. A concierge will switch your membership and confirm with you. Your billing date stays the same.');
          else say((x.j && x.j.error) || 'We could not send your request. Please try again or email info@casaconsignment.com.', true);
        })
        .catch(function(){ say('We could not send your request. Please try again or email info@casaconsignment.com.', true); })
        .then(function(){ if (btn) btn.disabled = false; });
    };

    // Surface it wherever the tier cards live, for people who already joined.
    function addManageLink(){
      // Top entry point (24 Sep 2026, Erich: easier to find). The bottom link below sat
      // after the tier cards and the fine print, where members missed it on phones.
      document.querySelectorAll('.casa-membership .section-head').forEach(function(h){
        if (h.querySelector('.casa-club-manage-top')) return;
        var t = document.createElement('p');
        t.className = 'casa-club-manage-top';
        t.style.cssText = 'margin:22px 0 0;';
        t.innerHTML = '<button type="button" class="btn btn-ghost" onclick="casaManageClub()">Already a member? Change tier or cancel</button>';
        h.appendChild(t);
      });
      document.querySelectorAll('.casa-membership .container').forEach(function(c){
        if (c.querySelector('.casa-club-manage')) return;
        var el = document.createElement('p');
        el.className = 'casa-club-manage';
        el.style.cssText = 'text-align:center; margin-top:18px; font-size:13px; color:var(--muted);';
        el.innerHTML = 'Already a member? <a onclick="casaManageClub()" style="color:var(--navy); text-decoration:underline; cursor:pointer;">Change tier or cancel →</a>';
        c.appendChild(el);
      });
    }
    addManageLink();
    setTimeout(addManageLink, 1200); setTimeout(addManageLink, 3000);
  })();

  // ---- Returning-member greeting -----------------------------------------
  // "Welcome back, Ms. Rivera." A full-screen curtain, held briefly, then out.
  //
  // Escapes both the salutation and the name. The salutation is allow-listed
  // server-side (api/auth/register.js) but the NAME is free text the customer
  // chose, and it is rendered on every sign-in — exactly the shape of a stored
  // XSS if it were interpolated raw.
  (function casaGreeting(){
    var st = document.createElement('style');
    st.textContent = [
      '.casa-greet{position:fixed;inset:0;z-index:400;display:flex;align-items:center;justify-content:center;',
      '  background:#141414;opacity:0;pointer-events:none;transition:opacity .55s cubic-bezier(.22,1,.36,1);}',
      '.casa-greet.in{opacity:1;}',
      '.casa-greet-inner{text-align:center;padding:0 24px;max-width:680px;}',
      '.casa-greet .mark{width:52px;height:1px;background:rgba(255,255,255,.35);margin:0 auto 26px;',
      '  transform:scaleX(0);transition:transform .7s cubic-bezier(.22,1,.36,1) .1s;}',
      '.casa-greet.in .mark{transform:scaleX(1);}',
      '.casa-greet .eyebrow{font-family:var(--sans);font-size:10px;letter-spacing:.42em;text-transform:uppercase;',
      '  color:rgba(255,255,255,.55);margin-bottom:18px;opacity:0;transform:translateY(8px);',
      '  transition:opacity .6s ease .18s, transform .6s cubic-bezier(.22,1,.36,1) .18s;}',
      '.casa-greet .line{font-family:var(--display,Georgia,serif);font-size:clamp(28px,5vw,52px);font-weight:400;',
      '  color:#fff;line-height:1.15;opacity:0;transform:translateY(14px);',
      '  transition:opacity .7s ease .3s, transform .7s cubic-bezier(.22,1,.36,1) .3s;}',
      '.casa-greet .line em{font-style:italic;}',
      '.casa-greet.in .eyebrow,.casa-greet.in .line{opacity:1;transform:translateY(0);}',
      '@media (prefers-reduced-motion: reduce){',
      '  .casa-greet,.casa-greet .mark,.casa-greet .eyebrow,.casa-greet .line{transition:opacity .2s linear;transform:none;}}'
    ].join('');
    document.head.appendChild(st);

    function esc(v){
      return String(v == null ? '' : v)
        .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }
    // "Ms. Rivera" if we have both; otherwise the first name; otherwise nothing.
    function address(u){
      var name = String((u && u.name) || '').trim();
      var sal  = String((u && u.salutation) || '').trim();
      if (!name) return '';
      var parts = name.split(/\s+/);
      // With an honorific, surname is the courteous pairing. Without one, first name.
      return sal ? sal + ' ' + parts[parts.length - 1] : parts[0];
    }

    window.casaWelcome = function(user, isNew){
      var who = address(user);
      var el = document.createElement('div');
      el.className = 'casa-greet';
      el.setAttribute('role','status');
      el.setAttribute('aria-live','polite');
      el.innerHTML =
        '<div class="casa-greet-inner">' +
          '<div class="mark"></div>' +
          '<div class="eyebrow">' + (isNew ? 'Casa Consignment' : 'The Casa Concierge Club') + '</div>' +
          '<div class="line">' +
            (isNew ? 'Welcome' : 'Welcome back') +
            (who ? ', <em>' + esc(who) + '</em>' : '') + '.' +
          '</div>' +
        '</div>';
      document.body.appendChild(el);
      requestAnimationFrame(function(){ el.classList.add('in'); });
      var done = function(){
        el.classList.remove('in');
        setTimeout(function(){ if (el.parentNode) el.parentNode.removeChild(el); }, 650);
      };
      setTimeout(done, 2200);
      // Never trap someone behind a decoration.
      el.addEventListener('click', done);
      document.addEventListener('keydown', function esc2(e){
        if (e.key === 'Escape'){ done(); document.removeEventListener('keydown', esc2); }
      });
    };
  })();

  // ---- Broken-image safety net -------------------------------------------
  // Several legacy So TEA asset folders ("Bags images/", "So Tea Additional
  // images/") never made it into this repo, and the paths that point at them are
  // built at runtime from string constants, so a static scan of src attributes
  // does not catch them. On a luxury storefront a broken-image icon is worse
  // than no image, so anything that fails to load is hidden rather than left to
  // render as a torn-page glyph.
  //
  // Capture phase, because `error` on <img> does not bubble.
  document.addEventListener('error', function(e){
    var el = e.target;
    if (!el || el.tagName !== 'IMG' || el.dataset.casaImgHandled) return;
    el.dataset.casaImgHandled = '1';
    el.style.display = 'none';
    // If the image was the only thing in its wrapper, drop the empty shell too
    // so the layout closes up instead of leaving a hole.
    var p = el.parentElement;
    if (p && p.children.length === 1 && !(p.textContent || '').trim()) p.style.display = 'none';
    console.warn('[casa] image failed to load, hidden:', el.getAttribute('src'));
  }, true);
  console.log('  ✓ Search: live filter over the hydrated catalogue (brand / model / colour / SKU)');
})();
